// extracted by mini-css-extract-plugin
export default {"hero_section":"Hero_section_hero_section__29JyG","wave":"Hero_section_wave__VXwsS"};